export default __webpack_public_path__ + "static/media/5zodic-signs.c969f36c.jpg";